<template>
    <header class="header has-shadow">
        <div class="container">
            <MainNavigation />
        </div>
    </header>
</template>
<script>
import MainNavigation from './MainNavigation';

export default {
    name: 'Header',
    components: { MainNavigation },
};
</script>
